import { Cart } from "../entity/Entity";

const CART_KEY = "cart_items";

export function getCart(): Cart[] {
    const raw = localStorage.getItem(CART_KEY);
    if (!raw) return [];
    try {
        return JSON.parse(raw);
    } catch {
        return [];
    }
}

export function setCart(cart: Cart[]): void {
    localStorage.setItem(CART_KEY, JSON.stringify(cart));
}

export function addToCart(item: Cart): void {
    const cart = getCart();
    const existing = cart.find(
        (c) =>
            c.item_id === item.item_id &&
            JSON.stringify(c.changeable_characteristics) ===
            JSON.stringify(item.changeable_characteristics)
    );

    if (existing) {
        existing.quantity += item.quantity;
    } else {
        cart.push(item);
    }

    setCart(cart);
}

export function removeFromCart(index: number): void {
    const cart = getCart();
    cart.splice(index, 1);
    setCart(cart);
}

export function clearCart(): void {
    localStorage.removeItem(CART_KEY);
}

export function updateCartQuantity(index: number, quantity: number) {
    const cart = getCart();
    cart[index].quantity = quantity;
    localStorage.setItem(CART_KEY, JSON.stringify(cart));
}
